// File: src/layouts/MentorParkLayout.jsx
// Description: Layout for Mentor Park with internal navigation for sub-sections

import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Box, Container, Typography, Button, Stack, useTheme, useMediaQuery } from '@mui/material';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Assessment from '@mui/icons-material/Assessment';
import Build from '@mui/icons-material/Build';
import School from '@mui/icons-material/School';
import Work from '@mui/icons-material/Work';
import Groups from '@mui/icons-material/Groups';

const MentorParkLayout = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const links = [
    { to: '/mentor-park/tools', label: 'Career Tools & Preparation', icon: <Build /> },
    { to: '/mentor-park/career-insights', label: 'Career Insights', icon: <TrendingUp /> },
    { to: '/mentor-park/skill-gap', label: 'Skill Gap Analysis', icon: <Assessment /> },
    { to: '/mentor-park/resources', label: 'Resources & Certifications', icon: <School /> },
    { to: '/mentor-park/job-alignment', label: 'Job Alignment Analysis', icon: <Work /> },
    { to: '/mentor-park/community', label: 'Community & Networking', icon: <Groups /> }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: { xs: 2, md: 3 } }}>
        <Typography variant={isMobile ? 'h4' : 'h3'} sx={{ fontWeight: 700, mb: 2 }}>
          Mentor Park
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Explore focused micro-ecosystems to accelerate your career growth.
        </Typography>

        {/* Internal Navigation */}
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} sx={{ mb: 3, flexWrap: 'wrap' }}>
          {links.map((item) => (
            <Button
              key={item.to}
              component={Link}
              to={item.to}
              startIcon={item.icon}
              variant={isActive(item.to) ? 'contained' : 'outlined'}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              {item.label}
            </Button>
          ))}
        </Stack>

        <Outlet />
      </Box>
    </Container>
  );
};

export default MentorParkLayout;


